import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIcon from "@mui/icons-material/Assignment";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const TaskAssignedModal = ({
  open,
  onClose,
  cipId,
  employeeList = [],
  onAssign,
}) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [taskDescription, setTaskDescription] = useState("");

  const handleSubmit = () => {
    if (!selectedEmployeeId || !taskDescription) {
      alert("Please complete all fields.");
      return;
    }

    const task = {
      cipId,
      assignedTo: selectedEmployeeId,
      description: taskDescription,
    };

    onAssign(task);
    setSelectedEmployeeId("");
    setTaskDescription("");
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setSelectedEmployeeId("");
      setTaskDescription("");
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {/* Encabezado */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            🛠️ Assign Task
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Formulario */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="employee-label">Assign to</InputLabel>
          <Select
            labelId="employee-label"
            value={selectedEmployeeId}
            label="Assign to"
            onChange={(e) => setSelectedEmployeeId(e.target.value)}
          >
            {employeeList.map((emp) => (
              <MenuItem key={emp.id} value={emp.id}>
                {emp.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Task Description"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={taskDescription}
          onChange={(e) => setTaskDescription(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Button
          fullWidth
          variant="contained"
          startIcon={<AssignmentIcon />}
          onClick={handleSubmit}
        >
          Assign Task
        </Button>
      </Box>
    </Modal>
  );
};

export default TaskAssignedModal;
